import ArrowBackIosNewTwoToneIcon from '@mui/icons-material/ArrowBackIosNewTwoTone';
import Stack from '@mui/material/Stack';

import useUserAuth from '@webclient/components/user-authentication/hooks/useUserAuth';

import useQueryParams from '@webclient/hooks/useQueryParams';

import { IconButton, Text } from '@knowz/knowz-ui';

export type Props = {
  heading: string;
  description?: string;
  withBackButton?: boolean;
  onClick?: () => void;
};

export default function FormHeading({
  heading,
  description,
  withBackButton = false,
  onClick,
}: Props) {
  const { handleBackStep, handleBackToEnterEmail } = useUserAuth();
  const { getQueryParamByKey } = useQueryParams();
  const subscriptionQueryParam = getQueryParamByKey('subscription');
  const paymentQueryParam = getQueryParamByKey('payment');

  function handleBackStepOnClick() {
    if (subscriptionQueryParam || paymentQueryParam) {
      handleBackToEnterEmail();
      handleBackStep();
      return;
    }
    handleBackStep();
  }

  return (
    <Stack
      sx={{ marginTop: 6 }}
      direction="row"
      gap={2}
    >
      {(withBackButton || onClick) && (
        <IconButton
          sx={{ mt: description ? 0 : -1 }}
          size="small"
          color="secondary"
          variant="ghost"
          onClick={onClick || handleBackStepOnClick}
        >
          <ArrowBackIosNewTwoToneIcon />
        </IconButton>
      )}

      <Stack>
        <Text
          variant="textLg"
          weight="semibold"
          component="h2"
        >
          {heading}
        </Text>

        {description && (
          <Text
            variant="textSm"
            color="text.tertiary"
          >
            {description}
          </Text>
        )}
      </Stack>
    </Stack>
  );
}
